import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const AdminLessonCategoryModal = (props) => {
    // const [teacher_option, set_teacher_option] = useState([]);
    // useEffect(() => {
    //     axios
    //         .get('/cramSchool/api/teacher')
    //         .then((response) => {
    //             const data_tmp = [];
    //             response.data.data.map((value) => {
    //                 data_tmp.push({ 'label': value.name, 'value': value.teacher_id })
    //             })
    //             set_teacher_option(data_tmp);
    //         })
    // }, [])
    return (
        <>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={400}
                footer={false}
                data={props.data}
                title={props.title}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >課程分類</Col>
                                    <Col>
                                        {props.edit ?
                                            <>
                                                {/* <Button>刪除貼文</Button> */}
                                            </> :
                                            <>
                                                {/* <Button>批次新增</Button> */}
                                            </>}
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={6}>分類名稱</Col>
                                    <Col span={18}>
                                        <Input placeholder={'請輸入課程分類名稱'} type='text' name="name" value={props.editcard['name']}
                                            onChange={e => props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        name: e.target.value,
                                                        title: e.target.value,
                                                    }
                                                )
                                            })} autoComplete='off' />
                                    </Col>
                                    <Col span={6}>分類說明</Col>
                                    <Col span={18}><Input.TextArea placeholder={'請輸入課程分類說明'} rows={4}  type='text' value={props.editcard.note} name="note" onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
                                    </Col>
                                    {/* <Col span={6}>授課老師</Col>
                                    <Col span={18}>
                                        <Checkbox.Group
                                            style={{
                                                width: '100%',
                                            }}
                                        // onChange={checkedValues => set_search_column(checkedValues)}
                                        // defaultValue={props.choose_column.map((value) => value.value)}
                                        >
                                            <Row>
                                                {teacher_option && teacher_option.map((value, index) => {
                                                    return (
                                                        <Col span={12}>
                                                            <Checkbox value={value.value}>{value.label}</Checkbox>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </Checkbox.Group>
                                    </Col> */}
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }} size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )

}
export default AdminLessonCategoryModal;